import { featuredStory, trendingTopics } from "@/mocks/gua";

export default function Hero() {
  return (
    <section id="home" className="px-4 md:px-6 pt-24 md:pt-28">
      <div className="mx-auto max-w-[1240px]">
        {/* 站标横幅 slogan */}
        <div className="mb-6 flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
          <div>
            <p className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-flashlight-fill text-[13px]" /> 热榜背后的故事 · 每日深扒
            </p>
            <h1 className="max-w-3xl font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
              只吃瓜是热闹，<span className="text-primary-600">看懂来龙去脉</span>才是本事
            </h1>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-foreground-500">
            背景分析 · 各方回应 · 舆论风向，把每一个争议热点的完整故事一次讲透。
          </p>
        </div>

        {/* 头条大图 */}
        <div className="relative overflow-hidden rounded-xl bg-foreground-950">
          <img
            src={featuredStory.img}
            alt={`${featuredStory.title} 头版新闻配图`}
            className="h-[300px] w-full object-cover object-top opacity-90 md:h-[460px]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-black/10" />
          <div className="absolute inset-x-0 bottom-0 flex flex-col justify-end gap-3 p-4 md:p-8">
            <div className="flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                <i className="ri-fire-fill" /> 今日头条
              </span>
              <span className="rounded-full bg-white/15 px-3 py-1 text-xs text-white backdrop-blur">
                深度长文
              </span>
            </div>
            <h2 className="max-w-4xl font-heading text-xl font-bold leading-snug text-white md:text-3xl">
              {featuredStory.title}
            </h2>
            <p className="max-w-2xl text-sm leading-relaxed text-white/80 md:text-base">
              {featuredStory.summary}
            </p>
            <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-white/70">
              {featuredStory.meta.map((m) => (
                <span key={m} className="inline-flex items-center gap-1">
                  <i className="ri-time-line" /> {m}
                </span>
              ))}
              <a
                href="#story"
                className="inline-flex items-center gap-1 whitespace-nowrap text-primary-300 hover:text-primary-200"
              >
                展开完整时间线 <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* 今日热议标签栏 */}
      <div className="mx-auto mt-10 max-w-[1240px]">
        <div className="flex items-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-500 text-background-50">
            <i className="ri-radar-line" />
          </span>
          <h3 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">今日热议风向</h3>
          <span className="ml-2 hidden text-xs text-foreground-400 sm:block">点击标签可跳转对应栏目</span>
        </div>
        <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
          {trendingTopics.map((t, i) => (
            <a
              key={t.tag}
              href="#fresh"
              className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-100/60 px-4 py-3 transition-colors hover:border-primary-300 hover:bg-background-50"
            >
              <span className="w-5 shrink-0 text-center font-heading text-sm font-bold text-secondary-500">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="flex min-w-0 flex-1 flex-col">
                <span className="truncate text-sm font-medium text-foreground-900 group-hover:text-primary-700">
                  {t.tag}
                </span>
                <span className="text-xs text-foreground-400">{t.label}</span>
              </span>
              <i
                className={`text-base ${
                  t.trend === "up"
                    ? "ri-arrow-up-line text-primary-500"
                    : t.trend === "down"
                      ? "ri-arrow-down-line text-accent-600"
                      : "ri-arrow-right-line text-foreground-300"
                }`}
              />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}